// Reports whether the browser currently has a network connection.
//
// Honest limitation: `navigator.onLine` only knows whether the machine has a
// network interface up. It cannot tell you the shop server is reachable.
//
// So it is NOT what the header badge uses. That asks the server directly, over
// `GET /api/health`, through the offline store - see `syncEngine.probeHealth`.
// This hook survives for the LOGIN PAGE alone, where there is no session yet,
// nothing has been queued, and the only useful thing to say is "this machine
// has no network at all".

import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
